import React from "react"
import PropTypes from "prop-types"
import ReactDropzone from "react-dropzone"
import request from "superagent"
import axios from "axios"

class UploadPdfZone extends React.Component {
  constructor(props) {
    super(props);
    this.purge = this.purge.bind(this)
    this.state = {
      files: [],
      images: [],
      preview: false,
      loading: false,
      done: false
    };
  }
  componentDidMount(){
  }

  purge(){
  }
  onPreviewDrop = (files) => {
    this.setState({
      files: files,
      preview: true,
      loading: true
     });
    var that = this

    const req = request.post('/api/v1/bien/uploadDerniereEntree');
    var sendfiles = []
    console.log(files)
    files.forEach(file => {
      req.attach("pdfs["+file.name+"]", file);
    });
    req.field("id",this.props.bien)
    req.end((err,res)=>{
      that.setState({
        loading: false,
        done: true
      })
    });
  }

  render() {
    const previewStyle = {
      display: 'inline',
      width: 200,
      height: 200,
    };

    return (
      <div className="app">
        {this.props.isimage ? (
            <h1 className="center">Uploader un autre fichier</h1>
          ) : (
            <h1 className="center"></h1>

          )}
        <div className="row">
          <div className="col s5 center ">
          {this.state.loading ? (
              <div>
                <p>Upload de l'image en cours</p>
              </div>
            ) : (
              <ReactDropzone
                accept="application/pdf"
                onDrop={this.onPreviewDrop}
                multiple={true}
              >
               <h2> Déposez ici votre état des lieux</h2>
              </ReactDropzone>

            )}


          </div>
          <div className="col s5">
            {this.state.done &&
              <h2 className="green-text container">
              L'état des lieux a bien été uploadé
              </h2>
            }
        </div>

        </div>
      </div>
    );
  }
}

export default UploadPdfZone
